import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Table,
  Form,
  Input,
  Button,
  Modal,
  Skeleton,
  Spin,
  Result,
} from "antd";
import { useDispatch } from "react-redux";
import { useTypedSelector } from "../../store";
import { redirect } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { createOrganisationRequest, getOrganisationRequest, resetMessageOrganisation, resetSuccessOrganisation, updateOrganisationRequest } from "../../slices/organisation";


const OrganisationSetting: React.FC = () => {
  const dispatch = useDispatch();
  const [formAdd] = Form.useForm();
  const [formEdit] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);
  const [editingOrganisation, setEditingOrganisation] = useState<any>(null);
  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState<any>(null);
  const [isAddMode, setIsAddMode] = useState(false);

  const {
    organisationList,
    loading,
    isLogin,
    isSuccess,
    messageErr,
    isUpdate,
    isCreate,
  } = useTypedSelector((state) => ({
    organisationList: state.Organisation.organisationList,
    loading: state.Organisation.pageIsLoading,
    isLogin: state.Auth.isLogin,
    isSuccess: state.Organisation.isSuccess,
    messageErr: state.Organisation.message,
    isUpdate: state.Organisation.organisationUpdate,
    isCreate: state.Organisation.organisationPost,
  }));

  useEffect(() => {
    if (!isLogin) {
      redirect("/login");
    } else {
      dispatch(getOrganisationRequest() as any);
    }
  }, [isUpdate, isCreate]);

  useEffect(() => {
    dispatch(resetMessageOrganisation());
  }, []);

  useEffect(() => {
    if (editingOrganisation) {
      formEdit.setFieldsValue(editingOrganisation);
    }
  }, [editingOrganisation]);

  const columns = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Organisation Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <Button
          type="primary"
          style={{ backgroundColor: "#faad14", borderColor: "#faad14" }}
          onClick={() => handleEdit(record)}
        >
          Edit
        </Button>
      ),
    },
  ];

  const handleEdit = (department: any) => {
    setEditingOrganisation(department);
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditingOrganisation(null);
    setOpenModal(false);
    dispatch(resetMessageOrganisation());
    dispatch(resetSuccessOrganisation());
    formAdd.resetFields();
    formEdit.resetFields();
  };

  const showConfirmationModal = (values: any, isAdd: boolean) => {
    setModalData(values);
    setIsAddMode(isAdd);
    setOpenModal(true);
  };

  const handleModalOk = () => {
    if (isAddMode) {
      onFinish(modalData);
    } else {
      onFinishUpdate(modalData);
    }
  };

  const onFinish = (values: any) => {
    dispatch(createOrganisationRequest(values) as any);
  };

  const onFinishUpdate = (values: any) => {
    console.log("EDIT Values", values);

    dispatch(updateOrganisationRequest(values) as any);
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Row gutter={16}>
        <Col span={16}>
          {!loading ? (
            <Table columns={columns} dataSource={organisationList} rowKey="_id" />
          ) : (
            <Skeleton active />
          )}
        </Col>

        <Col span={8}>
          <div
            style={{
              backgroundColor: "#EEEEEE",
              marginBottom: 2,
              marginLeft: 10,
              borderColor: "#eaeaea",
              borderStyle: "solid",
              borderRadius: "7px",
              padding: 20,
            }}
          >
            <h4>Add Organisation</h4>
            <Form
              form={formAdd}
              layout="vertical"
              onFinish={(values) => showConfirmationModal(values, true)}
              style={{ maxWidth: 400, margin: "0 auto" }}
            >
              <Form.Item
                label="Organisation Name"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Please input the organisation name!",
                  },
                ]}
              >
                <Input />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginRight: 20 }}
                >
                  Submit
                </Button>
                <Button onClick={handleCancel}>Cancel</Button>
              </Form.Item>
            </Form>
          </div>

          {isEditing && (
            <div
              style={{
                backgroundColor: "#E4E0E1",
                marginTop: 15,
                marginLeft: 10,
                borderColor: "#eaeaea",
                borderStyle: "solid",
                borderRadius: "7px",
                padding: 20,
              }}
            >
              <h4>Edit Organisation</h4>
              <Form
                form={formEdit}
                layout="vertical"
                onFinish={(values) =>
                  showConfirmationModal(
                    { ...editingOrganisation, ...values },
                    !isEditing
                  )
                }
                initialValues={editingOrganisation || {}}
                style={{ maxWidth: 400, margin: "0 auto" }}
              >
                <Form.Item
                  label="Organisation Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input the organisation name!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{
                      marginRight: 20,
                      backgroundColor: "#faad14",
                      borderColor: "#faad14",
                    }}
                  >
                    Update
                  </Button>
                  <Button onClick={handleCancel}>Cancel & Close</Button>
                </Form.Item>
              </Form>
            </div>
          )}
        </Col>
      </Row>

      <Modal
        open={openModal}
        title="Confirm Action"
        onCancel={handleCancel}
        cancelText="Close"
        onOk={handleModalOk}
        okButtonProps={
          isSuccess || messageErr.length > 0
            ? { style: { display: "none" } }
            : {}
        }
      >
        <p>
          {isAddMode
            ? "Are you sure you want to add this organisation?"
            : "Are you sure you want to edit this organisation?"}
        </p>
        {loading && (
          <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        )}
        {isSuccess && (
          <Result status="success" title="Successfully to Request" />
        )}
        {messageErr.length > 0 && (
          <Result status="warning" title={messageErr} />
        )}
      </Modal>
    </div>
  );
};

export default OrganisationSetting;
